import type { Category, Todo } from "../../domain/entities.ts";
import { activeTags } from "./selectors.ts";

export function boardColumnsForCategory(category: Category | undefined): string[] {
  return category?.boardColumns || [];
}

export function composerBoardPlacement(todo: Todo, category: Category | undefined): { column: string | null; tags: string[] } {
  const columns = boardColumnsForCategory(category);
  const tags = activeTags(todo);
  return { column: columns.includes(tags[0]) ? tags[0] : null, tags: tags.filter(tag => !columns.includes(tag)) };
}

export function composerTagOrder(tags: string[], category: Category | undefined, column: string | null): string[] {
  const columns = boardColumnsForCategory(category);
  const ordinary = [...new Set(tags.map(tag => tag.trim().toLowerCase()).filter(tag => tag && !columns.includes(tag)))];
  return column && columns.includes(column) ? [column, ...ordinary] : ordinary;
}

export function updateComposerColumnField(form: HTMLFormElement, category: Category | undefined): string[] {
  const field = form.querySelector<HTMLElement>("[data-composer-column]");
  const select = field?.querySelector<HTMLSelectElement>("[name=boardColumn]");
  if (!field || !select) return [];
  const columns = boardColumnsForCategory(category);
  const option = (label: string, value: string) => { const item = document.createElement("option"); item.textContent = label; item.value = value; return item; };
  select.replaceChildren(option("Unassigned", ""), ...columns.map(column => option(column, column)));
  select.value = "";
  field.hidden = !columns.length;
  const tagsInput = form.elements.namedItem("tags") as HTMLInputElement | null;
  const tags = [...new Set((tagsInput?.value || "").split(",").map(tag => tag.trim().toLowerCase()).filter(Boolean))];
  const removed = tags.filter(tag => columns.includes(tag));
  if (tagsInput && removed.length) tagsInput.value = tags.filter(tag => !columns.includes(tag)).join(", ");
  return removed;
}
